n
<template>
  <div>
    <div v-html="content" :style="this.style"/>
  </div>
</template>
<script>
export default {
  name: 'Wp_home_content_model',
  props: {
    params: { type: Object },
    list: { type: Array },
  },
  data () {
    return {
      content: '文案',
      style: '',
    }
  },
  watch: {
    params: {
      handler (nV, oV) {
        this.content = ''
        if (nV && nV.content) {
          this.content = nV.content
        }
        if (nV && nV.style) {
          this.style = nV.style
        }
      },
      immediate: true,
      deep: true,
    }
  },
  mounted () {
    console.log(this.params)
  }
}
</script>
<style>
ul {
  margin: 0;
  padding: 0;
  list-style: inside;
}

ol {
  margin: 0;
  padding: 0;
  list-style: decimal inside;
}
</style>